<template>

  <div class="">

    <div>
      <b class="text-2xl"> Nastevenia aplikácie</b>
    </div>

    <template v-if="!loading">
      <div class="flex mt-4 items-center space-x-2">
        <Checkbox v-model="settings.freeDeliveryActive" :binary="true"/>
        <div class="text-primary-800">Doprava je zdarma</div>
      </div>

      <div class="flex mt-4 items-center space-x-2">
        <Checkbox v-model="settings.appIsActiveBo" :binary="true"/>
        <div class="text-primary-800">Aplikacia je aktivovaná Bošany</div>
      </div>

      <div class="flex mt-4 items-center space-x-2">
        <Checkbox v-model="settings.appIsActivePe" :binary="true"/>
        <div class="text-primary-800">Aplikacia je aktivovaná Partizánske</div>
      </div>

      <div class="flex mt-4 items-center space-x-2">
        <div class="text-primary-800">od</div>
        <DatePicker id="datepicker-timeonly" v-model="settings.deliveryFromBo" timeOnly fluid/>
        <div class="text-primary-800">do</div>
        <DatePicker id="datepicker-timeonly" v-model="settings.deliveryToBo" timeOnly fluid/>
        <div class="text-primary-800">Dobprava Bošany</div>
      </div>

      <div class="flex mt-4 items-center space-x-2">
        <div class="text-primary-800">od</div>
        <DatePicker id="datepicker-timeonly" v-model="settings.deliveryFromPe" timeOnly fluid/>
        <div class="text-primary-800">do</div>
        <DatePicker id="datepicker-timeonly" v-model="settings.deliveryToPe" timeOnly fluid/>
        <div class="text-primary-800">Dobprava Partizánske</div>
      </div>

      <Button @click="saveSettings" :loading="saveing" label="Uložiť" class="w-[230px] mt-4"/>

    </template>
  </div>

</template>

<script setup>
import {ref, onMounted, nextTick, reactive, onUnmounted, watch} from 'vue'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {useRouter} from "vue-router";
import Supabase from "@/utils/Supabase.js";
import {useToast} from "primevue/usetoast";

const toast = useToast();

const settings = reactive({
  freeDeliveryActive: true,
  appIsActiveBo: true,
  appIsActivePe: true,
  deliveryFromBo: new Date(),
  deliveryToBo: new Date(),
  deliveryFromPe: new Date(),
  deliveryToPe: new Date(),
})

const loading = ref(false)
const loadSettings = async () => {
  loading.value = true
  const {data, error} = await Supabase.from('v2_Hajcer_App_Settings').select().limit(1)
  loading.value = false
  if (error) {
    toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
  } else {
    if (data.length !== 1) {
      toast.add({severity: 'error', summary: 'Error', detail: 'Settings not found', life: 3000});
    } else {
      const keys = Object.keys(data[0])
      keys.forEach(key => {
        if (key.startsWith('delivery')) {
          settings[key] = new Date(data[0][key])
        } else {
          settings[key] = data[0][key]
        }
      })
    }
  }
}
loadSettings()

const saveing = ref(false)
const saveSettings = async () => {
  saveing.value = true
  const {data, error} = await Supabase.from('v2_Hajcer_App_Settings').upsert({...settings})

  saveing.value = false

  if (error) {
    toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
  } else {
    toast.add({severity: 'success', summary: 'Success', detail: 'Saved', life: 3000});
  }
}

</script>